import { FieldSchema } from "../../../Schema";

/**
 * The picture shown for the equipment, as a file name.
 *
 * Chosen from the model's master data rather than typed, and never edited directly on the
 * equipment. Clusters have no image, which is why this sits with equipment rather than in
 * `common`.
 */
export const displayImage: FieldSchema = {
  name: "displayImage",
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Display image", disabled: true, displayed: false },
};
